/* ------------------------------------------------------------------------
	* LC Switch
	* superlight jQuery plugin improving forms look and functionality
	*
	* @version: 	1.1
	* @requires:	jQuery v1.7 or later
	* @author:		Luca Montanari (LCweb)
	* @website:		https://lcweb.it

	* Licensed under the MIT license
------------------------------------------------------------------------- */

(function(){
	"use strict";
	if(typeof($.fn.lc_switch) != 'undefined') {return false;} // prevent multiple script inits



	$.fn.lc_switch = function(on_text, off_text) {

		// destruct
		$.fn.switch_destroy = function() {

			$(this).each(function() {
                var $wrap = $(this).parents('.switch__wrap');

				$wrap.children().not('input').remove();
				$(this).unwrap();
            });

			return true;
		};



		// set to ON
		$.fn.switch_on = function() {
			$(this).each(function(i, v) {
				var $wrap 	= $(this).closest('.switch__wrap'),
					$input 	= $wrap.find('input');
				
				// if is already on - skip
				if($wrap.find('.switch').hasClass('switch--on')) {
					return true;
				}

				(typeof($.fn.prop) == 'function') ? $input.prop('checked', true) : $input.attr('checked', true);

				$input.trigger('switch-on');
				$input.trigger('switch-statuschange');
				$wrap.find('.switch').removeClass('switch--off').addClass('switch--on');

				// if radio - disable other ones
				if( $wrap.find('.switch').hasClass('switch--radio') ) {
					var f_name = $input.attr('name');
					$input.closest('form').find('input[name="'+f_name+'"]').not($input).switch_off();
				}
                $input.change();
            });

			return true;
		};



		// set to OFF
		$.fn.switch_off = function() {

			$(this).each(function() {
				var $wrap 	= $(this).closest('.switch__wrap'),
					$input 	= $wrap.find('input');

				// if is already off - skip
				if(!$wrap.find('.switch').hasClass('switch--on')) {
					return true;
				}

				// uncheck
				(typeof($.fn.prop) == 'function') ? $input.prop('checked', false) : $input.removeAttr('checked');

				$input.trigger('switch-off');
				$input.trigger('switch-statuschange');
				$wrap.find('.switch').removeClass('switch--on').addClass('switch--off');
                $input.change();
            });

			return true;
		};



		// toggle status
		$.fn.switch_toggle = function() {
			$(this).each(function() {

				// not for radios
				if( $(this).hasClass('switch--radio')) {
					return true;
				}

				($(this).is(':checked')) ? $(this).switch_off() : $(this).switch_on();
            });

			return true;
		};



		// construct
		return this.each(function(){

			// check against double init
			if( !$(this).parent().hasClass('switch__wrap') ) {

				// default texts
				var ckd_on_txt 	= (typeof(on_text) == 'undefined') ? 'ON' : on_text,
					ckd_off_txt = (typeof(off_text) == 'undefined') ? 'OFF' : off_text;

			   // labels structure
				var on_label 	= (ckd_on_txt) ? '<div class="switch__label switch__label--on">'+ ckd_on_txt +'</div>' : '',
					off_label 	= (ckd_off_txt) ? '<div class="switch__label switch__label--off">'+ ckd_off_txt +'</div>' : '';


				// default states
				var disabled 	= ($(this).is(':disabled')) ? true : false,
					active 		= ($(this).is(':checked'))  ? true : false;

				var status_classes = '';
				status_classes += (active) ? ' switch--on' : ' switch--off';
				if(disabled) {
					status_classes += ' switch--disabled';
				}


				// wrap and append
				var structure =
				$('<div class="switch '+status_classes+'">' +
					'<div class="switch__cursor"></div>' +
					on_label + off_label +
				'</div>');

				if( $(this).is(':input') && ($(this).attr('type') == 'checkbox' || $(this).attr('type') == 'radio') ) {

					$(this).wrap('<div class="switch__wrap"></div>');
					$(this).parent().append(structure);

					$(this).parent().find('.switch').addClass('switch--'+ $(this).attr('type'));
				}

                structure.click(function() {
                    if( $(this).hasClass('switch--on') ) {
                        if( !$(this).hasClass('switch--radio') ) { // not for radio
                            $(this).switch_off();
                        }
                    } else {
                        $(this).switch_on();
                    }
                })

                $(this).change(function() {
                    ( $(this).is(':checked') ) ? $(this).switch_on() : $(this).switch_off();
                })
			}
        });
	};
})(jQuery);
